import { Component } from 'preact';

const cache = {};

export class Slot extends Component {
  constructor(props, context) {
    super(props, context);
    this.context.slots.register(this.props.name, this.update);
  }
  update = content => {
    this.setState({ content });
  };
  render(
    props,
    {
      content = cache[this.props.name] &&
      cache[this.props.name][window.location.pathname]
        ? cache[this.props.name][window.location.pathname]
        : props.children,
    }
  ) {
    return content[0];
  }
}

export class SlotProvider {
  onChange = {};
  getChildContext() {
    const { onChange } = this;
    return {
      slots: {
        onChange,
        register: (name, cb) => {
          onChange[name] = cb;
        },
      },
    };
  }
  render(props) {
    return props.children[0];
  }
}
export class SlotContent extends Component {
  constructor(props, context) {
    super(props, context);
    cache[this.props.slot] = cache[this.props.slot] || {};
    cache[this.props.slot][window.location.pathname] = this.props.children;

    this.props.children;
    this.context.slots.onChange[this.props.slot](this.props.children);
  }
  componentWillUnmount() {
    this.context.slots.onChange[this.props.slot](void 0);
  }
  componentWillReceiveProps({ children, slot }) {
    const slots = this.context.slots;
    if (slots.onChange[slot]) {
      slots.onChange[slot](children);
    }
  }
  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./components/slots/index.js